export const columns = [
  /*     {
            field: 'transportation.content',
            headerName: 'Başlık',
            width: 200,
            renderCell: data => {
                console.log(data)
                return <span> {data?.row?.transportation?.title.slice()}</span>;
            },
        }, */
  {
    field: 'transportation.status',
    headerName: 'DURUM',
    width: 125,
    renderCell: (data) => {
      return (
        <span>
          {data?.row?.transportation?.status === 'COMPLETED'
            ? 'TAMAMLANDI'
            : 'BAŞLATILDI'}
        </span>
      );
    },
  },
  /* {
            field: 'transportation.succeeded',
            headerName: 'BAŞARI DURUMU',
            width: 150,
            renderCell: data => {
                return (
                    <span>
                        {data.row.transportation.succeeded ===undefined ? 'DEVAM EDİYOR': data?.row?.transportation?.succeeded
                            ? 'BAŞARILI'
                            : 'BAŞARISIZ'}
                    </span>
                );
            },
        }, */
  {
    field: 'transportation.vehicle.id',
    headerName: 'Araç Plakası',
    width: 115,
    renderCell: (data) => {
      return <span>{data?.row?.transportation?.vehicle?.id}</span>;
    },
  },
  {
    field: 'transportation.driver.id',
    headerName: 'Şoför Adı Soyadı',
    width: 160,
    renderCell: (data) => {
      return (
        <span>
          {data?.row?.transportation?.driver?.id}
          {/* {data?.employee?.user?.firstname} {data?.employee?.user?.lastname} */}
        </span>
      );
    },
  },
  {
    field: 'transportation.beginDate',
    headerName: 'Başlangıç Zamanı',
    width: 170,
    renderCell: (data) => {
      return (
        <span>
          {data?.row?.transportation?.beginDate
            ? new Date(data?.row?.transportation?.beginDate).toLocaleString(
                'tr',
              )
            : '-'}
          {/* {data?.employee?.user?.firstname} {data?.employee?.user?.lastname} */}
        </span>
      );
    },
  },

  {
    field: 'transportation.endDate',
    headerName: 'Bitiş Zamanı',
    width: 170,
    renderCell: (data) => {
      return (
        <span>
          {data?.row?.transportation?.endDate
            ? new Date(data?.row?.transportation?.endDate).toLocaleString('tr')
            : '-'}
          {/* {data?.employee?.user?.firstname} {data?.employee?.user?.lastname} */}
        </span>
      );
    },
  },
];
/* {
        "id": "4e1b8632057e44648345048ef5ca54ad",
        "schema": {
            "id": 1,
            "title": "AYD | Schema - 1",
            "seatSchema": {
                "id": 1
            },
            "driver": {
                "id": "fadimanakilci"
            },
            "vehicle": {
                "id": "07TEST42"
            },
            "premises": {
                "id": "Test"
            },
            "status": "ACTIVE",
            "createdAt": "2023-01-05T17:00:59.013111+03:00",
            "updatedAt": "2023-01-25T15:28:49.226986+03:00"
        },
        "transportation": {
            "id": "1",
            "driver": {
                "id": "fadimanakilci"
            },
            "vehicle": {
                "id": "07TEST42"
            },
            "type": "DEFAULT",
            "title": "AYD | 2023-01-05 17:03",
            "content": "AYD | 2023-01-05 17:03",
            "status": "COMPLETED",
            "beginDate": "2023-01-05T17:03:32.431411+03:00",
            "endDate": "2023-01-06T07:16:17.767549+03:00",
            "availability": "ACTIVE",
            "createdAt": "2023-01-05T17:03:32.43889+03:00",
            "updatedAt": "2023-01-18T03:43:08.405512+03:00"
        },
        "createdAt": "2023-01-18T03:50:01.512738+03:00",
        "updatedAt": "2023-01-18T03:50:01.512738+03:00"
    } */
